import lensPath from 'ramda/src/lensPath'
import over from 'ramda/src/over'
import prepend from 'ramda/src/prepend'
import { DROP_UPLOAD_KEYS_ON_SUCCESS } from 'root/src/client/logic/tableItem/actionIds'
import { DROP_KEYS_LIST_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import createListStoreKey from 'root/src/client/logic/api/util/createListStoreKey'
import { rewardEndpointIds } from 'root/src/shared/rewards/constants'
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'

export default {
	[DROP_UPLOAD_KEYS_ON_SUCCESS]: (state, payload) => {
		const [item] = payload
		const { id } = item
		const listStoreKey = createListStoreKey(
			{ routeId: routeUrls.keysAndProducts() },
			rewardEndpointIds.GET_DROP_KEY_REWARDS,
			DROP_KEYS_LIST_MODULE_ID,
		)

		return over(lensPath(['api', 'lists', listStoreKey, 'items']), prepend(id), state)
	},
}
